import { Route } from '@angular/router';
import {
  AccessDeniedComponent,
  AppConfig,
  authGuard,
  CadastrarComponent,
  EditarComponentComponent,
  loggedInGuard,
  LoginComponent,
  permissionGuard,
  PessoaMinhaContaComponent, // ✅ Re-exportado do shared-common-ui
  PlanoExpiradoComponent,
  RecuperarSenhaComponent,
  SistemaEnum, // ✅ Re-exportado do shared-common-ui
} from '@nomoh-monorepo/shared-common-ui';
import { PERMISSIONS } from '@nomoh-monorepo/shared-types';

const NOMOH_ADMIN_CONFIG: AppConfig = {
  app: 'nomoh-administrador',
  title: 'Nomoh Administrador',
  theme: 'nomoh-admin-theme',
  dashboardRoute: '/dashboard',
  sistema: SistemaEnum.Nomoh, // ✅ Sistema Nomoh (código: 1)
};

const DADOS_LAYOUT = {
  // Dados do layout - validação de permissão por item
  items: [
    {
      label: 'Home',
      icon: 'pi pi-home',
      link: '/dashboard',
      permission: PERMISSIONS.NOMOH_PESSOAS_READ,
    },
    {
      label: 'Usuario',
      icon: 'pi pi-users',
      link: '/users',
      permission: PERMISSIONS.NOMOH_PESSOAS_LIST,
    },
    {
      label: 'Planos',
      icon: 'pi pi-box',
      link: '/planos',
      permission: PERMISSIONS.NOMOH_PLANOS_LIST,
    },
    {
      label: 'Sistemas',
      icon: 'pi pi-server',
      link: '/sistemas',
      permission: PERMISSIONS.NOMOH_SISTEMAS_LIST,
    },
    {
      label: 'Permissões',
      icon: 'pi pi-shield',
      link: '/permissions',
      permission: PERMISSIONS.NOMOH_PERMISSIONS_LIST,
    },
    {
      label: 'Descontos',
      icon: 'pi pi-percentage',
      link: '/descontos',
      permission: PERMISSIONS.NOMOH_DESCONTOS_READ,
    },
    {
      label: 'Histórico de Planos',
      icon: 'pi pi-history',
      link: '/historico-planos',
      permission: PERMISSIONS.NOMOH_PLANO_HISTORICO_READ,
    },
    {
      label: 'Pagamentos',
      icon: 'pi pi-credit-card',
      link: '/pagamentos',
      permission: PERMISSIONS.NOMOH_PAGAMENTOS_READ,
    },
    {
      label: 'Fluxos',
      icon: 'pi pi-sitemap',
      link: '/fluxos',
      permission: PERMISSIONS.NOMOH_FLUXOS_LIST,
    },
    {
      label: 'Chamados',
      icon: 'pi pi-inbox',
      link: '/chamados',
      permission: PERMISSIONS.NOMOH_CHAMADOS_LIST,
    },
    {
      label: 'Perguntas Frequentes',
      icon: 'pi pi-question-circle',
      link: '/faq',
      permission: PERMISSIONS.NOMOH_FAQ_LIST,
    },
  ],
  logo: 'logo.png',
  homeRoute: '/dashboard',
  badgeIsVisible: true,
};

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loggedInGuard],
    data: { appConfig: NOMOH_ADMIN_CONFIG },
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
    data: { appConfig: NOMOH_ADMIN_CONFIG },
  },
  {
    path: 'cadastrar',
    component: CadastrarComponent,
    data: { appConfig: NOMOH_ADMIN_CONFIG },
  },
  {
    path: 'editar/:id',
    component: EditarComponentComponent,
    data: { appConfig: NOMOH_ADMIN_CONFIG },
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'plano-expirado',
    component: PlanoExpiradoComponent,
  },
  {
    path: 'minha-conta/:pessoaId',
    component: PessoaMinhaContaComponent,
  },
  {
    path: 'privacidade',
    loadComponent: () =>
      import('@nomoh-monorepo/shared-common-ui').then(
        (m) => m.PrivacidadeComponent
      ),
    data: { systemName: 'Nomoh Administrador' },
  },

  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_PESSOAS_READ],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-dashboard'
              ).then((m) => m.FeatureDashboardComponent),
          },
        ],
      },
      // {
      //   path: 'minha-conta',
      //   loadComponent: () =>
      //     import('@nomoh-monorepo/shared-layout').then(
      //       (m) => m.FeatureSMainComponent
      //     ),
      //   data: {
      //     ...DADOS_LAYOUT,
      //   },
      //   children: [
      //     {
      //       path: ':pessoaId',
      //       component: PessoaMinhaContaComponent,
      //       data: { appConfig: NOMOH_ADMIN_CONFIG },
      //     },
      //   ],
      // },
      {
        path: 'users',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_PESSOAS_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@nomoh-monorepo/nomoh-administrador-feature-users').then(
                (m) => m.FeatureUsersComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-user-detalhes'
              ).then((m) => m.FeatureUserDetalhesComponent),
          },
        ],
      },
      {
        path: 'planos',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_PLANOS_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@nomoh-monorepo/nomoh-administrador-feature-planos').then(
                (m) => m.FeaturePlanosComponent
              ),
          },
        ],
      },
      {
        path: 'sistemas',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_SISTEMAS_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-sistemas'
              ).then((m) => m.FeatureSistemasComponent),
          },
        ],
      },
      {
        path: 'permissions',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_PERMISSIONS_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-permissions'
              ).then((m) => m.FeaturePermissionsComponent),
          },
        ],
      },
      {
        path: 'admin-test',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_TEST_VIEW],
          requireAll: true,
        },
      },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      {
        path: 'descontos',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_DESCONTOS_READ],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-descontos'
              ).then((m) => m.FeatureDescontosComponent),
          },
        ],
      },
      {
        path: 'historico-planos',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_PLANO_HISTORICO_READ],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-historico-planos'
              ).then((m) => m.FeatureHistoricoPlanosComponent),
          },
        ],
      },
      {
        path: 'pagamentos',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_PAGAMENTOS_READ],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                '@nomoh-monorepo/nomoh-administrador-feature-pagamentos'
              ).then((m) => m.FeaturePagamentosComponent),
          },
        ],
      },
      {
        path: 'fluxos',
        // TODO: Adicionar permissionGuard quando a permissão NOMOH_FLUXOS_LIST existir no banco
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_FLUXOS_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@nomoh-monorepo/nomoh-administrador-feature-fluxo').then(
                (m) => m.FeatureFluxoComponent
              ),
          },
        ],
      },
      {
        path: 'chamados',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_CHAMADOS_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@nomoh-monorepo/nomoh-administrador-feature-chamados').then(
                (m) => m.FeatureChamadosListComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('@nomoh-monorepo/nomoh-administrador-feature-chamados').then(
                (m) => m.FeatureChamadosDetalheComponent
              ),
          },
        ],
      },
      {
        path: 'faq',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('@nomoh-monorepo/shared-layout').then(
            (m) => m.FeatureSMainComponent
          ),
        data: {
          ...DADOS_LAYOUT,
          permissions: [PERMISSIONS.NOMOH_FAQ_LIST],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@nomoh-monorepo/nomoh-administrador-feature-faq').then(
                (m) => m.FeatureFaqComponent
              ),
          },
        ],
      },
    ],
  },
];
